// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import App from './App'
import router from './router'
Vue.config.productionTip = false

import axios from 'axios'
Vue.prototype.$axios = axios

import * as echarts from 'echarts'
Vue.prototype.$echarts = echarts

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// 将方法挂载到vue原型上
Vue.prototype.localhost_url = "http://www.corner.com.cn";

new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

//自定义组件



// WEBPACK FOOTER //
// ./src/main.js